import React from 'react';
import { formatUtcToIst } from '../utils/datetime';
import { formatStatusLabel } from '../api/ticketsApi';
import TicketStatusBadge from './TicketStatusBadge';

function TimelineItem({ item, index }) {
  const type = item.type || item.event_type || 'update';
  const when = item.created_at || item.timestamp || item.at;
  const actor = item.actor_name || item.user_name || item.by || 'System';

  let title = item.title || item.action || type;
  if (type === 'status_change') {
    title = `Status changed to ${formatStatusLabel(item.to_status || item.status)}`;
  } else if (type === 'assignment') {
    title = item.title || `Assigned to ${(item.assignees || []).join(', ') || item.assignee_name || 'engineer'}`;
  } else if (type === 'comment') {
    title = 'Comment added';
  } else if (type === 'created') {
    title = 'Ticket created';
  } else if (type === 'closure') {
    title = 'Ticket closed';
  } else if (type === 'reopen') {
    title = 'Ticket reopened';
  }

  return (
    <div
      className="tk-timeline-item"
      style={{ animationDelay: `${Math.min(index, 8) * 40}ms` }}
    >
      <div className="tk-timeline-dot" />
      <div className="tk-timeline-body">
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', alignItems: 'center', marginBottom: '4px' }}>
          <span style={{ fontWeight: '600', fontSize: '12px', color: '#0F172A' }}>{title}</span>
          {item.status && <TicketStatusBadge status={item.status} />}
        </div>
        {item.details && (
          <p style={{ margin: '4px 0', fontSize: '12px', color: '#475569' }}>{item.details}</p>
        )}
        {item.comment && (
          <p style={{ margin: '4px 0', fontSize: '12px', color: '#475569', fontStyle: 'italic' }}>
            &ldquo;{item.comment}&rdquo;
          </p>
        )}
        {item.reason && (
          <p style={{ margin: '4px 0', fontSize: '12px', color: '#475569' }}>Reason: {item.reason}</p>
        )}
        <p className="tk-mono" style={{ margin: '4px 0 0', fontSize: '11px', color: '#94A3B8' }}>
          {actor} · {formatUtcToIst(when)}
        </p>
      </div>
    </div>
  );
}

function TicketTimeline({ events = [], timeline = [] }) {
  const items = events.length ? events : timeline;

  if (!items.length) {
    return (
      <p style={{ color: '#94A3B8', fontSize: '12px', margin: 0 }}>No timeline events yet.</p>
    );
  }

  return (
    <div style={{ paddingLeft: '4px' }}>
      {items.map((item, idx) => (
        <TimelineItem key={item.id || item.event_id || idx} item={item} index={idx} />
      ))}
    </div>
  );
}

export default TicketTimeline;
